// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"74a2c382","361":"24c44a94","511":"46bf3ecc","767":"0d147d09"}[chunkId] + ".chunk.js";
};